// Area: query (owner record-ops in wave 1, views-grid in wave 2). The records query surface,
// moved out of the records module unchanged.
import { QueryRequest, QueryResponse } from '@dataroom/core';
import { z } from 'zod';
import { defineContract } from '../define';

export { QueryRequest, QueryResponse };

export const queryRecordsContract = defineContract({
  method: 'POST',
  path: '/objects/:key/query',
  params: z.object({ key: z.string().min(1).max(63) }),
  body: QueryRequest,
  response: QueryResponse,
  summary: 'Query records: filter AST, sort, fields, cursor, full-text q, counts, groupBy + aggregates',
});
